angular.module("digitalLeasing.module").component("financialContacts", {
  templateUrl: "ng/components/digitalLeasing/financialLeasingRequest/financialContacts/financialContacts.view.html",
  bindings: {
    id: "<",
    model: "=",
    onStructureChanges: "&",
    riUserG: "=",
    prodotto: "=",
    noteIsVisible: "=",
    bankIsVisible: "=",
    componentIsOk: "&",
    componentIsNotOk: "&",
    validityCustomer: "&",
    validityBank: "&",
    volturanteIsVisible: "=",
    changeLabel: "=",
    initialTabIndex: "=",
    cessionarioIsVisible: "=",
    contatti: "<",
    isM9: "<",
    isRP: "<"
  },
  controllerAs: "financialContactsCtrl",
  controller: FinancialContactsController,
});

function FinancialContactsController(
  Riferimenti,
  $timeout,
  $portalService,
  validationService
) {
  var self = this;

  self.$onInit = function () {
    self.$portalService = $portalService;
    self.supportModel = {
      initialIndex: 0
    };

    $timeout(function () {
      self.supportModel.initialIndex = self.initialTabIndex || 0;

      if (self.model.riferimenti.length > 0) {
        self.model.riferimenti.forEach(function (element) {
          switch (element.id) {
            case "CLIENTE":
              self.supportModel.client = {
                id: element.id,
                email: validationService.emailRegex.test(element.email) ? element.email : "",
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "FORNITORE":
              self.supportModel.provider = {
                id: element.id,
                email: validationService.emailRegex.test(element.email) ? element.email : "",
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "NOTAIO":
              self.supportModel.notary = {
                id: element.id,
                email: validationService.emailRegex.test(element.email) ? element.email : "",
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "RIFERIMENTO PER ISPEZIONI":
              self.supportModel.reference = {
                id: element.id,
                email: validationService.emailRegex.test(element.email) ? element.email : "",
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "BANCA":
              self.supportModel.bank = {
                id: element.id,
                email: validationService.emailRegex.test(element.email) ? element.email : "",
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "VOLTURANTE":
              self.supportModel.volturante = {
                id: element.id,
                email: validationService.emailRegex.test(element.email) ? element.email : "",
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "CESSIONARIO":
              self.supportModel.cessionario = {
                id: element.id,
                email: validationService.emailRegex.test(element.email) ? element.email : "",
                telefono: element.telefono,
                description: element.description,
              };

              break;
          }
        });
      } else {
        self.supportModel = {
          client: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          },
          provider: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          },
          notary: {
            id: "",
            email: "",
            telefono: "",
            escription: "",
          },
          reference: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          },
          bank: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          },
          volturante: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          },
          cessionario: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          }
        };
      }

      checkValidation();

    }, 500);
  };

  self.$onChanges = function (changes) {
    console.log("changes: ", changes);

    $timeout(function () {
      self.supportModel.initialIndex = self.initialTabIndex || 0;

      if (self.model.riferimenti.length > 0) {
        self.model.riferimenti.forEach(function (element) {
          switch (element.id) {
            case "CLIENTE":
              self.supportModel.client = {
                id: element.id,
                email: element.email,
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "FORNITORE":
              self.supportModel.provider = {
                id: element.id,
                email: element.email,
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "NOTAIO":
              self.supportModel.notary = {
                id: element.id,
                email: element.email,
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "RIFERIMENTO PER ISPEZIONI":
              self.supportModel.reference = {
                id: element.id,
                email: element.email,
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "BANCA":
              self.supportModel.bank = {
                id: element.id,
                email: element.email,
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "VOLTURANTE":
              self.supportModel.volturante = {
                id: element.id,
                email: element.email,
                telefono: element.telefono,
                description: element.description,
              };

              break;
            case "CESSIONARIO":
              self.supportModel.cessionario = {
                id: element.id,
                email: element.email,
                telefono: element.telefono,
                description: element.description,
              };

              break;
          }
        });
      } else {
        self.supportModel = {
          client: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          },
          provider: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          },
          notary: {
            id: "",
            email: "",
            telefono: "",
            escription: "",
          },
          reference: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          },
          bank: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          },
          volturante: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          },
          cessionario: {
            id: "",
            email: "",
            telefono: "",
            description: "",
          }
        };
      }

      checkValidation();
      validationComponent();

    }, 1500);
  }

  self.handleChange = function (property, value) {
    if (property) {
      if (property == 'note') {
        self.model[property] = value && value.replace(/[\u0000-\u001f]/gi, '')
          .replace(/[\u0080-\u009f]/gi, '')
          .replace(/[\u0100-\uffff]/gi, '');
      } else {
        self.model[property] = value;
      }

      self.onStructureChanges({
        finContactsStructure: self.model,
      });
      console.log("Client contacts: ", self.model);
    }
  };

  self.handleRifChange = function (type, property, value) {
    switch (type) {
      case "note":
        self.model[property] = value && value.replace(/[\u0000-\u001f]/gi, '')
          .replace(/[\u0080-\u009f]/gi, '')
          .replace(/[\u0100-\uffff]/gi, '');
        break;
      case "client":
        self.supportModel.client.id = "CLIENTE";
        self.supportModel.client[property] = value;

        var index = self.model.riferimenti.findIndex(function (el) {
          return el.id == self.supportModel.client.id;
        });

        if (index != -1) {
          self.model.riferimenti.splice(index, 1);
        }
        self.model.riferimenti.push(
          Riferimenti.build(self.supportModel.client)
        );

        break;
      case "provider":
        self.supportModel.provider.id = "FORNITORE";
        self.supportModel.provider[property] = value;

        var index = self.model.riferimenti.findIndex(function (el) {
          return el.id == self.supportModel.provider.id;
        });

        var tel = self.supportModel.provider.telefono &&
          self.supportModel.provider.telefono.substring(0, 12);
        self.supportModel.provider.telefono = tel;

        if (index != -1) {
          self.model.riferimenti.splice(index, 1);
        }
        self.model.riferimenti.push(
          Riferimenti.build(self.supportModel.provider)
        );
        break;
      case "notary":
        if (self.supportModel.notary) {
          self.supportModel.notary.id = "NOTAIO";
          self.supportModel.notary[property] = value;

          var index = self.model.riferimenti.findIndex(function (el) {
            return el.id == self.supportModel.notary.id;
          });

          var tel = self.supportModel.notary.telefono &&
            self.supportModel.notary.telefono.substring(0, 12);
          self.supportModel.notary.telefono = tel;

          if (index != -1) {
            self.model.riferimenti.splice(index, 1);
          }
          self.model.riferimenti.push(
            Riferimenti.build(self.supportModel.notary)
          );
        }
        break;
      case "reference":
        if (self.supportModel.reference) {
          self.supportModel.reference.id = "RIFERIMENTO PER ISPEZIONI";
          self.supportModel.reference[property] = value;

          var index = self.model.riferimenti.findIndex(function (el) {
            return el.id == self.supportModel.reference.id;
          });

          var tel = self.supportModel.reference.telefono &&
            self.supportModel.reference.telefono.substring(0, 12);
          self.supportModel.reference.telefono = tel;

          if (index != -1) {
            self.model.riferimenti.splice(index, 1);
          }
          self.model.riferimenti.push(
            Riferimenti.build(self.supportModel.reference)
          );
        }
        break;
      case "bank":
        if (self.supportModel.bank && self.supportModel.bank.id) {
          self.supportModel.bank.id = "BANCA";
          self.supportModel.bank[property] = value;

          var index = self.model.riferimenti.findIndex(function (el) {
            return el.id == self.supportModel.bank.id;
          });

          var tel = self.supportModel.bank.telefono &&
            self.supportModel.bank.telefono.substring(0, 12);
          self.supportModel.bank.telefono = tel;

          if (index != -1) {
            self.model.riferimenti.splice(index, 1);
          }
          self.model.riferimenti.push(
            Riferimenti.build(self.supportModel.bank)
          );
        }
        break;
      case "volturante":
        self.supportModel.volturante.id = "VOLTURANTE";
        self.supportModel.volturante[property] = value;

        var index = self.model.riferimenti.findIndex(function (el) {
          return el.id == self.supportModel.volturante.id;
        });

        var tel = self.supportModel.volturante.telefono &&
          self.supportModel.volturante.telefono.substring(0, 12);
        self.supportModel.volturante.telefono = tel;

        if (index != -1) {
          self.model.riferimenti.splice(index, 1);
        }
        self.model.riferimenti.push(
          Riferimenti.build(self.supportModel.volturante)
        );

        break;
      case 'cessionario':
        self.supportModel.cessionario.id = "CESSIONARIO";
        self.supportModel.cessionario[property] = value;

        var index = self.model.riferimenti.findIndex(function (el) {
          return el.id == self.supportModel.cessionario.id;
        });

        var tel = self.supportModel.cessionario.telefono &&
          self.supportModel.cessionario.telefono.substring(0, 12);
        self.supportModel.cessionario.telefono = tel;

        if (index != -1) {
          self.model.riferimenti.splice(index, 1);
        }
        self.model.riferimenti.push(
          Riferimenti.build(self.supportModel.cessionario)
        );

        break;
      default:
        break;
    }
    validationComponent();

    self.onStructureChanges({
      finContactsStructure: self.model,
    });
  };

  var validationComponent = function () {
    if (self.supportModel.client &&
      self.supportModel.client.email &&
      self.supportModel.client.telefono &&
      self.supportModel.client.description
    ) {
      self.validityCustomer({
        validity: true,
      });
    } else {
      self.validityCustomer({
        validity: false,
      });
    }

    if (self.supportModel.bank &&
      self.supportModel.bank.email &&
      self.supportModel.bank.telefono &&
      self.supportModel.bank.description
    ) {
      self.validityBank({
        validity: true,
      });
    } else {
      self.validityBank({
        validity: false,
      });
    }

    checkValidation();
  }


  var checkValidation = function () {
    var client = false;
    var bank = false;
    var cessionario = false;
    var volturante = false;

    //condizione base 
    client = self.supportModel.client &&
      self.supportModel.client.email &&
      self.supportModel.client.telefono &&
      self.supportModel.client.description;

    if (self.bankIsVisible) {
      bank = self.supportModel.bank &&
        self.supportModel.bank.email &&
        self.supportModel.bank.telefono &&
        self.supportModel.bank.description;
    } else {
      bank = true;
    }

    if (self.cessionarioIsVisible) {
      cessionario = self.supportModel.cessionario &&
        self.supportModel.cessionario.email &&
        self.supportModel.cessionario.telefono &&
        self.supportModel.cessionario.description;
    } else {
      cessionario = true;
    }

    if (self.volturanteIsVisible) {
      volturante = self.supportModel.volturante &&
        self.supportModel.volturante.email &&
        self.supportModel.volturante.telefono &&
        self.supportModel.volturante.description;
    } else {
      volturante = true;
    }

    if (client && bank && cessionario && volturante) {
      self.componentIsOk();
    } else {
      self.componentIsNotOk();
    }
  }
}